import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

// Public pages
import LandingPage   from './pages/LandingPage';
import ApplyPage     from './pages/ApplyPage';
import ThankYouPage  from './pages/ThankYouPage';

// Admin pages
import AdminLoginPage       from './pages/admin/AdminLoginPage';
import AdminDashboardPage   from './pages/admin/AdminDashboardPage';
import AdminApplicationsPage from './pages/admin/AdminApplicationsPage';
import AdminApplicationDetailPage from './pages/admin/AdminApplicationDetailPage';
import AdminSettingsPage    from './pages/admin/AdminSettingsPage';
import AdminLayout          from './components/admin/AdminLayout';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('adeona_token');
  return token ? children : <Navigate to="/admin/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/"          element={<LandingPage />} />
        <Route path="/apply"     element={<ApplyPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard"            element={<AdminDashboardPage />} />
          <Route path="applications"         element={<AdminApplicationsPage />} />
          <Route path="applications/:id"     element={<AdminApplicationDetailPage />} />
          <Route path="settings"             element={<AdminSettingsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
